module.exports = __webpack_public_path__ + "static/media/Seam_8000.cb04a2d6.jpg";